function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#C3ECFB;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#5AA861;}\n\t.st3{fill:#348938;}\n\t.st4{opacity:0.5;}\n\t.st5{fill:#006837;}\n\t.st6{opacity:0.4;}\n\t.st7{fill:#95B772;}\n\t.st8{fill:#054419;}\n\t.st9{fill:#A34A3B;}\n\t.st10{fill:#7A3229;}\n\t.st11{fill:#632925;}\n\t.st12{fill:#B57521;}\n\t.st13{fill:#350E0A;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "background"
}, React.createElement("g", {
  id: "sky",
  transform: "translate(30.000000, 13.000000)"
}, React.createElement("path", {
  id: "Path",
  className: "st0",
  d: "M207.9,771.1C79.2,689.3,0,577.6,0,454.4C0,203.5,329.1,0,735,0s735,203.5,735,454.4 c0,123.1-79.2,234.9-207.9,316.7H207.9L207.9,771.1z"
})), React.createElement("g", {
  id: "clouds",
  transform: "translate(228.000000, 98.000000)"
}, React.createElement("g", {
  id: "big-cloud",
  transform: "translate(754.000000, 0.000000)"
}, React.createElement("g", {
  id: "big_cloud"
}, React.createElement("path", {
  className: "st1",
  d: "M273.7,97.2c2.3-3.5,3.5-7.5,3.5-11.6c0-19-26.4-34.4-59.8-35.6c0.9-2.6,1.4-5.4,1.4-8.1 c0-22.6-31-40.9-69.2-40.9c-32.9,0-60.4,13.5-67.5,31.7c-3.9-1.9-8.2-2.9-12.5-2.8c-12.3,0-22.3,7.4-22.3,16.5 c0,3,1.1,5.9,3,8.2c-29.4,7-49.5,21-49.5,37.3c0,1.8,0.3,3.6,0.8,5.4H273.7L273.7,97.2z"
}))), React.createElement("g", {
  id: "big-cloud_1_",
  transform: "translate(584.500000, 285.000000) scale(-1, 1) translate(-584.500000, -285.000000) translate(485.000000, 250.000000)"
}, React.createElement("g", {
  id: "big_cloud_1_"
}, React.createElement("path", {
  className: "st1",
  d: "M195.9,69.4c1.6-2.5,2.5-5.4,2.5-8.3c0-13.5-18.9-24.6-42.8-25.4c0.7-1.9,1-3.8,1-5.8 c0-16.1-22.2-29.2-49.6-29.2c-23.5,0-43.2,9.7-48.3,22.6c-2.8-1.4-5.8-2.1-8.9-2c-8.8,0-15.9,5.3-15.9,11.8 c0,2.1,0.8,4.2,2.1,5.9c-21,5-35.4,15-35.4,26.6c0,1.3,0.2,2.6,0.5,3.9H195.9L195.9,69.4z"
}))), React.createElement("g", {
  id: "medium-cloud",
  transform: "translate(95.000000, 20.000000)"
}, React.createElement("g", {
  id: "Path_1_"
}, React.createElement("path", {
  className: "st1",
  d: "M246.1,79.8H6.9c-1.3,0-2.6-0.6-3.4-1.7c-2.2-2.7-3.5-6.1-3.6-9.7c0-11.2,13-20.5,29.7-21.7 c2-0.1,3.7-1.7,3.9-3.8C35.9,19.4,61.6,0.9,92.9,0.9c17.9,0,33.9,6.1,44.8,15.6c1.2,1.1,3,1.3,4.4,0.6c8.5-4,21.4-6.5,35.8-6.5 c25.7,0,46.6,8.1,46.6,18c0,3-1.9,5.8-5.3,8.3c-1.2,0.8-1.9,2.3-1.8,3.7c0.1,1.5,1,2.8,2.3,3.4c16.4,8,27.5,18.5,30.4,30.7 c0.3,1.2,0,2.5-0.8,3.5S247.3,79.8,246.1,79.8z"
}))), React.createElement("g", {
  id: "medium-cloud_1_",
  transform: "translate(110.000000, 384.000000) scale(-1, 1) translate(-110.000000, -384.000000) translate(0.000000, 349.000000)"
}, React.createElement("g", {
  id: "Path_2_"
}, React.createElement("path", {
  className: "st1",
  d: "M215.7,69.8H6.1c-1.2,0-2.2-0.5-2.9-1.5c-2-2.4-3.1-5.4-3.1-8.4C0,50,11.4,42,26,40.9 c1.8-0.1,3.2-1.5,3.4-3.3C31.5,17,54,0.8,81.4,0.8c15.7,0,29.7,5.3,39.3,13.7c1.1,0.9,2.6,1.1,3.9,0.5 c7.5-3.5,18.8-5.7,31.4-5.7c22.6,0,40.8,7.1,40.8,15.8c0,2.6-1.7,5.1-4.6,7.3c-1.1,0.7-1.6,2-1.5,3.3c0.1,1.3,0.9,2.4,2,3 c14.4,7,24.1,16.2,26.6,26.8c0.2,1.1,0,2.2-0.7,3C217.8,69.3,216.8,69.8,215.7,69.8z"
}))), React.createElement("g", {
  id: "medium-cloud_2_",
  transform: "translate(784.000000, 325.000000)"
}, React.createElement("g", {
  id: "Path_3_"
}, React.createElement("path", {
  className: "st1",
  d: "M110.8,33.9H3.1c-0.6,0-1.2-0.3-1.5-0.7C0.6,32,0,30.6,0,29.1c0-4.8,5.8-8.7,13.4-9.2 c0.9-0.1,1.6-0.7,1.7-1.6c1.1-10,12.6-17.9,26.7-17.9c8,0,15.3,2.6,20.2,6.6c0.5,0.5,1.3,0.6,2,0.3c3.8-1.7,9.6-2.8,16.1-2.8 c11.6,0,21,3.4,21,7.7c0,1.3-0.9,2.5-2.4,3.5c-0.5,0.4-0.8,1-0.8,1.6c0.1,0.6,0.4,1.2,1,1.4c7.4,3.4,12.4,7.9,13.7,13 c0.1,0.5,0,1.1-0.4,1.5S111.3,33.9,110.8,33.9z"
})))), React.createElement("g", {
  id: "hills",
  transform: "translate(30.000000, 261.000000)"
}, React.createElement("g", {
  id: "hill-group-right",
  transform: "translate(882.000000, 1.000000)"
}, React.createElement("g", {
  id: "large-hill",
  transform: "translate(180.000000, 0.000000)"
}, React.createElement("g", {
  id: "hill1"
}, React.createElement("path", {
  id: "hill_shape",
  className: "st2",
  d: "M43,2h166.6c21,0,38,17,38,38v477.7H5V40C5,19,22,2,43,2z"
}), React.createElement("g", {
  id: "pattern_group",
  transform: "translate(4.000000, 4.000000)"
}, React.createElement("path", {
  id: "Path_4_",
  className: "st3",
  d: "M172.2,322c-20.5,0-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-20.1-17.8-40.6-17.8c-12.5,0-21.5,3.5-28.5,8.1v17.7c8-6.5,15-11.8,28.5-11.8c15.2,0,22.6,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2c15.2,0,22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8v-14c-15.2,0-22.5-6.6-31-14.2C203.2,331.4,192.7,322,172.2,322z"
}), React.createElement("path", {
  id: "Path_5_",
  className: "st3",
  d: "M172.2,277c-20.5,0-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-20.1-17.8-40.6-17.8c-12.5,0-21.5,3.5-28.5,8.1v17.7c8-6.5,15-11.8,28.5-11.8c15.2,0,22.6,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2c15.2,0,22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8v-14c-15.2,0-22.5-6.6-31-14.2C203.2,286.4,192.7,277,172.2,277z"
}), React.createElement("path", {
  id: "Path_6_",
  className: "st3",
  d: "M172.2,231c-20.5,0-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-20.1-17.8-40.6-17.8c-12.5,0-21.5,3.5-28.5,8.1v17.7c8-6.5,15-11.8,28.5-11.8c15.2,0,22.6,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2c15.2,0,22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8v-14c-15.2,0-22.5-6.6-31-14.2C203.2,240.4,192.7,231,172.2,231z"
}), React.createElement("path", {
  id: "Path_7_",
  className: "st3",
  d: "M172.2,186c-20.5,0-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-20.1-17.8-40.6-17.8c-12.5,0-21.5,3.5-28.5,8.1v17.7c8-6.5,15-11.8,28.5-11.8c15.2,0,22.6,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2c15.2,0,22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8v-14c-15.2,0-22.5-6.6-31-14.2C203.2,195.4,192.7,186,172.2,186z"
}), React.createElement("path", {
  id: "Path_8_",
  className: "st3",
  d: "M172.2,140c-20.5,0-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-20.1-17.8-40.6-17.8c-12.5,0-21.5,3.5-28.5,8.1v17.7c8-6.5,15-11.8,28.5-11.8c15.2,0,22.6,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2c15.2,0,22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8v-14c-15.2,0-22.5-6.6-31-14.2C203.2,149.4,192.7,140,172.2,140z"
}), React.createElement("path", {
  id: "Path_9_",
  className: "st3",
  d: "M172.2,95c-20.5,0-31.1,9.5-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 C60.4,104.4,49.6,95,29.1,95C16.6,95,7.6,98.4,0.6,103v17.7c8-6.5,15-11.8,28.5-11.8c15.2,0,22.6,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2c15.2,0,22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8v-14c-15.2,0-22.5-6.6-31-14.2C203.2,104.4,192.7,95,172.2,95z"
}), React.createElement("path", {
  id: "Path_10_",
  className: "st3",
  d: "M172.2,49c-20.5,0-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 C60.4,58.4,49.6,49,29.1,49C16.6,49,7.6,52.4,0.6,57v17.7c8-6.5,15-11.8,28.5-11.8c15.2,0,22.6,6.6,31.1,14.2 C69.5,85.5,80.1,95,100.7,95s31.1-9.4,40.4-17.8C149.6,69.6,157,63,172.1,63c15.2,0,22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8V81c-15.2,0-22.5-6.6-31-14.2C203.2,58.4,192.7,49,172.2,49z"
}), React.createElement("path", {
  id: "Path_11_",
  className: "st3",
  d: "M212.5,21.7C203.2,13.4,192.7,4,172.2,4s-31.1,9.5-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2 s-22.5-6.6-31-14.2C60.4,13.4,49.8,4,29.3,4c-4.3,0-8.5,0.4-12.7,1.4c-7.9,5.7-13.2,14.3-15,23.9C8.9,22.9,16.1,18,29.3,18 c15.2,0,22.5,6.6,31,14.2C69.6,40.5,80.2,50,100.7,50s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31-14.2c15.2,0,22.5,6.6,31,14.2 c9.3,8.3,19.9,17.8,40.4,17.8V36C228.4,36,221.1,29.4,212.5,21.7z"
}), React.createElement("path", {
  id: "Path_12_",
  className: "st3",
  d: "M125.5-2H76c6.4,4,14.3,6,24.8,6S119.1,2,125.5-2z"
}), React.createElement("path", {
  id: "Path_13_",
  className: "st3",
  d: "M141.4,514h61.5c-7.5-6-16.8-9.8-30.8-9.8S148.9,508,141.4,514z"
}), React.createElement("path", {
  id: "Path_14_",
  className: "st3",
  d: "M0.6,512v1.9h59.5c-7.5-6-17-9.9-31-9.9C16.6,504.1,7.6,507.4,0.6,512z"
}), React.createElement("path", {
  id: "Path_15_",
  className: "st3",
  d: "M172.2,459c-20.5,0-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-20.1-17.8-40.6-17.8c-12.5,0-21.5,3.5-28.5,8.1v17.7c8-6.5,15-11.8,28.5-11.8c15.2,0,22.6,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2c15.2,0,22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8v-14c-15.2,0-22.5-6.6-31-14.2C203.2,468.4,192.7,459,172.2,459z"
}), React.createElement("path", {
  id: "Path_16_",
  className: "st3",
  d: "M172.2,413c-20.5,0-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-20.1-17.8-40.6-17.8c-12.5,0-21.5,3.5-28.5,8.1v17.7c8-6.5,15-11.8,28.5-11.8c15.2,0,22.6,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2c15.2,0,22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8v-14c-15.2,0-22.5-6.6-31-14.2C203.2,422.4,192.7,413,172.2,413z"
}), React.createElement("path", {
  id: "Path_17_",
  className: "st3",
  d: "M172.2,368c-20.5,0-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-20.1-17.8-40.6-17.8c-12.5,0-21.5,3.5-28.5,8.1v17.7c8-6.5,15-11.8,28.5-11.8c15.2,0,22.6,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2c15.2,0,22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8v-14c-15.2,0-22.5-6.6-31-14.2C203.2,377.4,192.7,368,172.2,368z"
})), React.createElement("g", {
  id: "Group",
  transform: "translate(184.000000, 4.000000)",
  className: "st4"
}, React.createElement("path", {
  id: "Path_18_",
  className: "st5",
  d: "M25.6-2h-25c21,0.1,37.9,17.1,38,38v478h25V36C63.5,15,46.6-2,25.6-2z"
})), React.createElement("g", {
  id: "Group_1_",
  transform: "translate(4.000000, 4.000000)",
  className: "st6"
}, React.createElement("path", {
  id: "Path_19_",
  className: "st7",
  d: "M49-2H39C18.1-2,0.6,15.1,0.6,36v478h10V36C10.6,15.1,28.1-2,49-2z"
})), React.createElement("path", {
  id: "border",
  className: "st8",
  d: "M209.6,2c21,0.1,37.9,17,38,38v477.7H5V40C5.1,19,22,2.1,43,2H209.6L209.6,2z M209.6-3H43 C19.3-3,0,16.3,0,40v482.7h252.6V40C252.6,16.3,233.3-3,209.6-3L209.6-3z"
}))), React.createElement("g", {
  id: "middle-hill",
  transform: "translate(366.000000, 128.000000)"
}, React.createElement("g", {
  id: "hill2"
}, React.createElement("path", {
  id: "hill_shape_1_",
  className: "st2",
  d: "M43,2h166.6c21,0,38,17,38,38v349H5V40C5,19,22,2,43,2z"
}), React.createElement("g", {
  id: "pattern_group_1_",
  transform: "translate(5.000000, 5.000000)"
}, React.createElement("path", {
  id: "Path_20_",
  className: "st3",
  d: "M49.3,372.5c-15.6,0-25.5,4.8-33.4,11.8h66.8C74.8,377.3,65,372.5,49.3,372.5z"
}), React.createElement("path", {
  id: "Path_21_",
  className: "st3",
  d: "M192.2,372.5c-15.6,0-25.5,4.8-33.4,11.8h66.8C217.7,377.3,207.8,372.5,192.2,372.5z"
}), React.createElement("path", {
  id: "Path_22_",
  className: "st3",
  d: "M232.5,345c-9.3-8.3-19.8-17.8-40.4-17.8s-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2 s-22.5-6.6-31-14.2c-9.3-8.3-19.8-17.8-40.4-17.8S18.5,336.7,9.2,345c-2.8,2.6-5.7,5.1-8.7,7.4v16.2c7-3.5,12.9-8.5,18.1-13.2 c8.5-7.6,15.7-14.2,30.9-14.2s22.5,6.6,31,14.2c9.3,8.3,19.8,17.8,40.4,17.8s31.1-9.5,40.4-17.8c8.5-7.6,15.9-14.2,31-14.2 c15.2,0,22.5,6.6,31,14.2c5.4,4.9,11.3,10.1,19.3,13.7v-15.9C239.5,350.9,235.9,348,232.5,345z"
}), React.createElement("path", {
  id: "Path_23_",
  className: "st3",
  d: "M18.5,309.5c8.5-7.6,15.7-14.2,30.9-14.2s22.5,6.6,31,14.2c9.3,8.3,19.8,17.8,40.4,17.8 s31.1-9.5,40.4-17.8c8.5-7.6,15.9-14.2,31-14.2s22.5,6.6,31,14.2c5.4,4.9,11.3,10.1,19.3,13.7v-15.9c-3-2.3-6.6-5.2-10-8.1 c-9.3-8.3-19.8-17.8-40.4-17.8s-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-19.8-17.8-40.4-17.8S18.5,290.7,9.2,299c-2.8,2.6-5.7,5.1-8.7,7.4v16.2C7.5,319.1,13.3,314.1,18.5,309.5z"
}), React.createElement("path", {
  id: "Path_24_",
  className: "st3",
  d: "M18.5,264.5c8.5-7.6,15.7-14.2,30.9-14.2s22.5,6.6,31,14.2c9.3,8.3,19.8,17.8,40.4,17.8 s31.1-9.5,40.4-17.8c8.5-7.6,15.9-14.2,31-14.2s22.5,6.6,31,14.2c5.4,4.9,11.3,10.1,19.3,13.7v-15.9c-3-2.3-6.6-5.2-10-8.1 c-9.3-8.3-19.8-17.8-40.4-17.8s-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-19.8-17.8-40.4-17.8S18.5,245.7,9.2,254c-2.8,2.6-5.7,5.1-8.7,7.4v16.2C7.5,274.1,13.3,269.1,18.5,264.5z"
}), React.createElement("path", {
  id: "Path_25_",
  className: "st3",
  d: "M18.5,218.5c8.5-7.6,15.7-14.2,30.9-14.2s22.5,6.6,31,14.2c9.3,8.3,19.8,17.8,40.4,17.8 s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31-14.2s22.5,6.6,31,14.2c5.4,4.9,11.3,10.1,19.3,13.7v-15.9c-3-2.3-6.6-5.2-10-8.1 c-9.3-8.3-19.8-17.8-40.4-17.8s-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-19.8-17.8-40.4-17.8S18.5,199.7,9.2,208c-2.8,2.6-5.7,5.1-8.7,7.4v16.2C7.5,228.1,13.3,223.1,18.5,218.5z"
}), React.createElement("path", {
  id: "Path_26_",
  className: "st3",
  d: "M18.5,173.5c8.5-7.6,15.7-14.2,30.9-14.2s22.5,6.6,31,14.2c9.3,8.3,19.8,17.8,40.4,17.8 s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31-14.2s22.5,6.6,31,14.2c5.4,4.9,11.3,10.1,19.3,13.7v-15.9c-3-2.3-6.6-5.2-10-8.1 c-9.3-8.3-19.8-17.8-40.4-17.8s-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-19.8-17.8-40.4-17.8S18.5,154.7,9.2,163c-2.8,2.6-5.7,5.1-8.7,7.4v16.2C7.5,183.1,13.3,178.1,18.5,173.5z"
}), React.createElement("path", {
  id: "Path_27_",
  className: "st3",
  d: "M18.5,127.5c8.5-7.6,15.7-14.2,30.9-14.2s22.5,6.6,31,14.2c9.3,8.3,19.8,17.8,40.4,17.8 s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31-14.2s22.5,6.6,31,14.2c5.4,4.9,11.3,10.1,19.3,13.7v-15.9c-3-2.3-6.6-5.2-10-8.1 c-9.3-8.3-19.8-17.8-40.4-17.8s-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-19.8-17.8-40.4-17.8S18.5,108.7,9.2,117c-2.8,2.6-5.7,5.1-8.7,7.4v16.2C7.5,137.1,13.3,132.1,18.5,127.5z"
}), React.createElement("path", {
  id: "Path_28_",
  className: "st3",
  d: "M192.2,54.3c-20.5,0-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-19.9-17.8-40.4-17.8S18.5,63.7,9.2,72c-2.8,2.6-5.7,5.1-8.7,7.4v16.2c7-3.5,12.9-8.5,18.1-13.2 c8.5-7.6,15.7-14.2,30.9-14.2s22.5,6.6,31,14.2c9.3,8.3,19.8,17.8,40.4,17.8s31.1-9.5,40.4-17.8c8.5-7.6,15.9-14.2,31-14.2 s22.5,6.6,31,14.2c5.4,4.9,11.3,10.1,19.3,13.7V80.2c-3-2.3-6.6-5.2-10-8.1C223.2,63.7,212.7,54.3,192.2,54.3z"
}), React.createElement("path", {
  id: "Path_29_",
  className: "st3",
  d: "M0.5,49.6c7-3.5,12.9-8.5,18.1-13.2c8.5-7.6,15.7-14.2,30.9-14.2s22.5,6.6,31,14.2 c9.3,8.3,19.8,17.8,40.4,17.8s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31-14.2s22.5,6.6,31,14.2c5.4,4.9,11.3,10.1,19.3,13.7V35 c0-0.3,0-0.5,0-0.8c-3.5-2.5-6.8-5.2-10-8.1c-9.3-8.3-19.8-17.8-40.4-17.8s-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2 s-22.5-6.6-31-14.2C80.4,17.7,69.9,8.3,49.3,8.3S18.3,17.7,8.9,26c-2.7,2.6-5.6,5.1-8.7,7.4c0,0.5,0.2,1,0.2,1.6L0.5,49.6 L0.5,49.6z"
}), React.createElement("path", {
  id: "Path_30_",
  className: "st3",
  d: "M120.8,9.5c16,0,26-6.3,34-12.3h-68C94.8,3.3,104.7,9.5,120.8,9.5z"
})), React.createElement("g", {
  id: "Group_2_",
  transform: "translate(5.000000, 5.000000)",
  className: "st6"
}, React.createElement("path", {
  id: "Path_31_",
  className: "st7",
  d: "M48-2.7H38c-10,0-19.6,4-26.6,11.1S0.4,25,0.5,35v349.3h10V35c-0.1-10,3.9-19.6,10.9-26.7 S38-2.8,48-2.7L48-2.7z"
})), React.createElement("g", {
  id: "Group_3_",
  transform: "translate(189.000000, 5.000000)",
  className: "st4"
}, React.createElement("path", {
  id: "Path_32_",
  className: "st5",
  d: "M20.6-2.7h-20c10,0,19.7,3.9,26.8,11S38.5,25,38.5,35v349.3h20V35c0-10-4-19.6-11.1-26.7 S30.6-2.8,20.6-2.7z"
})), React.createElement("path", {
  id: "border_1_",
  className: "st8",
  d: "M209.6,2c21,0.1,37.9,17,38,38v349H5V40C5.1,19,22,2.1,43,2H209.6L209.6,2z M209.6-3H43 C19.3-3,0,16.3,0,40v354h252.6V40C252.6,16.3,233.3-3,209.6-3L209.6-3L209.6-3z"
}))), React.createElement("g", {
  id: "small-hill",
  transform: "translate(0.000000, 214.000000)"
}, React.createElement("g", {
  id: "hill3"
}, React.createElement("path", {
  id: "Path_33_",
  className: "st2",
  d: "M212.5,303.8H5V40C5.1,19,22,2.1,43,2h131.5c21,0.1,37.9,17,38,38V303.8L212.5,303.8z"
}), React.createElement("g", {
  id: "pattern_group_2_",
  transform: "translate(2.000000, 2.000000)"
}, React.createElement("path", {
  id: "Path_34_",
  className: "st3",
  d: "M213.4,303v-15.7c-9,3.5-14.9,9.2-20.6,14.3c-1.1,1-2.3,2-3.4,3h21.7 C211.6,303.9,212.4,303.3,213.4,303L213.4,303z"
}), React.createElement("path", {
  id: "Path_35_",
  className: "st3",
  d: "M130.5,301.6c-9.3-8.3-19.9-17.9-40.4-17.9s-31.1,9.6-40.4,17.9c-1.1,1-2.2,2-3.2,3h21.7 c5.7-4,12.2-6.6,21.9-6.6s16.2,2.6,21.9,6.6h21.7C132.6,303.7,131.6,302.6,130.5,301.6z"
}), React.createElement("path", {
  id: "Path_36_",
  className: "st3",
  d: "M90.1,252.7c15.2,0,22.5,6.6,31,14.2c9.3,8.3,19.9,17.8,40.4,17.8s31.3-9.4,40.6-17.8 c3.5-3.3,7.3-6.2,11.3-8.8v-15.7c-9,3.5-14.9,9-20.6,14.1c-8.5,7.6-16,14.2-31.1,14.2c-15.2,0-22.6-6.6-31.1-14.2 c-9.3-8.3-19.9-17.8-40.4-17.8s-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31.1,14.2c-6.3,0.1-12.6-1.3-18.2-4.3v15.3 c5.8,2.1,12,3.1,18.2,3c20.5,0,31.1-9.4,40.4-17.8C67.5,259.3,74.9,252.7,90.1,252.7z"
}), React.createElement("path", {
  id: "Path_37_",
  className: "st3",
  d: "M59,220.9c8.5-7.6,15.9-14.2,31-14.2s22.5,6.6,31,14.2c9.3,8.3,19.9,17.8,40.4,17.8 s31.3-9.4,40.6-17.8c3.5-3.3,7.3-6.2,11.3-8.8v-15.7c-9,3.5-14.9,9-20.6,14.1c-8.5,7.6-16,14.2-31.1,14.2 c-15.2,0-22.6-6.6-31.1-14.2c-9.3-8.3-19.9-17.8-40.4-17.8s-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31.1,14.2 c-6.3,0.1-12.6-1.3-18.2-4.3v15.3c5.8,2.1,12,3.1,18.2,3C39.1,238.7,49.7,229.2,59,220.9z"
}), React.createElement("path", {
  id: "Path_38_",
  className: "st3",
  d: "M192.8,165.5c-8.5,7.6-16,14.2-31.1,14.2c-15.2,0-22.6-6.6-31.1-14.2 c-9.3-8.3-19.9-17.8-40.4-17.8s-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31.1,14.2c-6.3,0.1-12.6-1.3-18.2-4.3v15.3 c5.8,2.1,12,3.1,18.2,3c20.5,0,31.1-9.5,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2s22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.3-9.4,40.6-17.8c3.5-3.3,7.3-6.2,11.3-8.8v-15.7C204.4,154.9,198.4,160.4,192.8,165.5z"
}), React.createElement("path", {
  id: "Path_39_",
  className: "st3",
  d: "M192.8,119.5c-8.5,7.6-16,14.2-31.1,14.2c-15.2,0-22.6-6.6-31.1-14.2 c-9.3-8.3-19.9-17.8-40.4-17.8s-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31.1,14.2c-6.3,0.1-12.6-1.3-18.2-4.3v15.3 c5.8,2.1,12,3.1,18.2,3c20.5,0,31.1-9.5,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2s22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.3-9.4,40.6-17.8c3.5-3.3,7.3-6.2,11.3-8.8v-15.7C204.4,108.9,198.4,114.4,192.8,119.5z"
}), React.createElement("path", {
  id: "Path_40_",
  className: "st3",
  d: "M192.8,74.5c-8.5,7.6-16,14.2-31.1,14.2c-15.2,0-22.6-6.6-31.1-14.2 c-9.3-8.3-19.9-17.8-40.4-17.8S59,66.1,49.7,74.5c-8.5,7.6-15.9,14.2-31.1,14.2C12.3,88.8,6,87.3,0.4,84.3v15.3 c5.8,2.1,12,3.1,18.2,3c20.5,0,31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2s22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.3-9.4,40.6-17.8c3.5-3.3,7.3-6.2,11.3-8.8V60.3C204.4,63.9,198.4,69.4,192.8,74.5z"
}), React.createElement("path", {
  id: "Path_41_",
  className: "st3",
  d: "M192.6,28.5c-8.5,7.6-15.9,14.2-31,14.2c-15.2,0-22.5-6.6-31-14.2 c-9.3-8.3-19.9-17.8-40.4-17.8S59,20.1,49.7,28.5c-8.5,7.6-15.9,14.2-31.1,14.2C12.3,42.8,6,41.3,0.4,38.3v15.3 c5.8,2.1,12,3.1,18.2,3c20.5,0,31.1-9.5,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2s22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.1-9.4,40.4-17.8c3.2-3.1,6.7-5.9,10.4-8.4c-0.9-4.7-2.6-9.2-5.1-13.3 C201.5,20.5,196.9,24.6,192.6,28.5z"
}), React.createElement("path", {
  id: "Path_42_",
  className: "st3",
  d: "M54.9-2.3H41c-11.6,0-22.6,4.9-30.3,13.6c2.6,0.4,5.3,0.6,7.9,0.6 C36.3,11.8,46.5,4.7,54.9-2.3z"
}), React.createElement("path", {
  id: "Path_43_",
  className: "st3",
  d: "M161.5,11.8c13.6,0,22.8-4.1,30.2-9.3c-5.9-3.2-12.5-4.8-19.2-4.8h-7.1 c-1.2,0-2.5,0.2-3.9,0.2s-2.6-0.2-3.9-0.2h-32.4C133.7,4.7,143.9,11.8,161.5,11.8z"
})), React.createElement("path", {
  id: "border_2_",
  className: "st8",
  d: "M174.5,2c21,0.1,37.9,17,38,38v263.8H5V40C5.1,19,22,2.1,43,2H174.5L174.5,2z M174.5-3H43 C19.3-3,0,16.3,0,40v268.8h217.5V40C217.5,16.3,198.2-3,174.5-3L174.5-3L174.5-3z"
}), React.createElement("g", {
  id: "Group_4_",
  transform: "translate(5.000000, 4.000000)",
  className: "st6"
}, React.createElement("path", {
  id: "Path_44_",
  className: "st7",
  d: "M48-2.3H38C17.1-2.3,0.4,15.1,0.4,36v263.7h10V36C10.4,15.1,27.1-2.3,48-2.3z"
})), React.createElement("g", {
  id: "Group_5_",
  transform: "translate(149.000000, 4.000000)",
  className: "st4"
}, React.createElement("path", {
  id: "Path_45_",
  className: "st5",
  d: "M25.5-2.3h-25c20.9,0,37.9,17.4,37.9,38.3v263.7h25V36C63.4,15.1,46.4-2.3,25.5-2.3z"
}))))), React.createElement("g", {
  id: "hill-group-left"
}, React.createElement("g", {
  id: "large-hill_1_"
}, React.createElement("path", {
  id: "hill_shape_2_",
  className: "st2",
  d: "M43,3h166.6c21,0,38,17,38,38v477.7H5V41C5,20,22,3,43,3z"
}), React.createElement("g", {
  id: "pattern_group_3_",
  transform: "translate(4.000000, 4.000000)"
}, React.createElement("path", {
  id: "Path_46_",
  className: "st3",
  d: "M172.2,323c-20.5,0-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-20.1-17.8-40.6-17.8c-12.5,0-21.5,3.5-28.5,8.1v17.7c8-6.5,15-11.8,28.5-11.8c15.2,0,22.6,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2c15.2,0,22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8v-14c-15.2,0-22.5-6.6-31-14.2C203.2,332.4,192.7,323,172.2,323z"
}), React.createElement("path", {
  id: "Path_47_",
  className: "st3",
  d: "M172.2,278c-20.5,0-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-20.1-17.8-40.6-17.8c-12.5,0-21.5,3.5-28.5,8.1v17.7c8-6.5,15-11.8,28.5-11.8c15.2,0,22.6,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2c15.2,0,22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8v-14c-15.2,0-22.5-6.6-31-14.2C203.2,287.4,192.7,278,172.2,278z"
}), React.createElement("path", {
  id: "Path_48_",
  className: "st3",
  d: "M172.2,232c-20.5,0-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-20.1-17.8-40.6-17.8c-12.5,0-21.5,3.5-28.5,8.1v17.7c8-6.5,15-11.8,28.5-11.8c15.2,0,22.6,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2c15.2,0,22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8v-14c-15.2,0-22.5-6.6-31-14.2C203.2,241.4,192.7,232,172.2,232z"
}), React.createElement("path", {
  id: "Path_49_",
  className: "st3",
  d: "M172.2,187c-20.5,0-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-20.1-17.8-40.6-17.8c-12.5,0-21.5,3.5-28.5,8.1v17.7c8-6.5,15-11.8,28.5-11.8c15.2,0,22.6,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2c15.2,0,22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8v-14c-15.2,0-22.5-6.6-31-14.2C203.2,196.4,192.7,187,172.2,187z"
}), React.createElement("path", {
  id: "Path_50_",
  className: "st3",
  d: "M172.2,141c-20.5,0-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-20.1-17.8-40.6-17.8c-12.5,0-21.5,3.5-28.5,8.1v17.7c8-6.5,15-11.8,28.5-11.8c15.2,0,22.6,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2c15.2,0,22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8v-14c-15.2,0-22.5-6.6-31-14.2C203.2,150.4,192.7,141,172.2,141z"
}), React.createElement("path", {
  id: "Path_51_",
  className: "st3",
  d: "M172.2,96c-20.5,0-31.1,9.5-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 C60.4,105.4,49.6,96,29.1,96C16.6,96,7.6,99.4,0.6,104v17.7c8-6.5,15-11.8,28.5-11.8c15.2,0,22.6,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2c15.2,0,22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8v-14c-15.2,0-22.5-6.6-31-14.2C203.2,105.4,192.7,96,172.2,96z"
}), React.createElement("path", {
  id: "Path_52_",
  className: "st3",
  d: "M172.2,50c-20.5,0-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 C60.4,59.4,49.6,50,29.1,50C16.6,50,7.6,53.4,0.6,58v17.7c8-6.5,15-11.8,28.5-11.8c15.2,0,22.6,6.6,31.1,14.2 C69.5,86.5,80.1,96,100.7,96s31.1-9.4,40.4-17.8C149.6,70.6,157,64,172.1,64c15.2,0,22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8V82c-15.2,0-22.5-6.6-31-14.2C203.2,59.4,192.7,50,172.2,50z"
}), React.createElement("path", {
  id: "Path_53_",
  className: "st3",
  d: "M212.5,22.7C203.2,14.4,192.7,5,172.2,5s-31.1,9.5-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2 s-22.5-6.6-31-14.2C60.4,14.4,49.8,5,29.3,5c-4.3,0-8.5,0.4-12.7,1.4c-7.9,5.7-13.2,14.3-15,23.9C8.9,23.9,16.1,19,29.3,19 c15.2,0,22.5,6.6,31,14.2C69.6,41.5,80.2,51,100.7,51s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31-14.2c15.2,0,22.5,6.6,31,14.2 c9.3,8.3,19.9,17.8,40.4,17.8V37C228.4,37,221.1,30.4,212.5,22.7z"
}), React.createElement("path", {
  id: "Path_54_",
  className: "st3",
  d: "M125.5-1H76c6.4,4,14.3,6,24.8,6S119.1,3,125.5-1z"
}), React.createElement("path", {
  id: "Path_55_",
  className: "st3",
  d: "M141.4,515h61.5c-7.5-6-16.8-9.8-30.8-9.8S148.9,509,141.4,515z"
}), React.createElement("path", {
  id: "Path_56_",
  className: "st3",
  d: "M0.6,513v1.9h59.5c-7.5-6-17-9.9-31-9.9C16.6,505.1,7.6,508.4,0.6,513z"
}), React.createElement("path", {
  id: "Path_57_",
  className: "st3",
  d: "M172.2,460c-20.5,0-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-20.1-17.8-40.6-17.8c-12.5,0-21.5,3.5-28.5,8.1v17.7c8-6.5,15-11.8,28.5-11.8c15.2,0,22.6,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2c15.2,0,22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8v-14c-15.2,0-22.5-6.6-31-14.2C203.2,469.4,192.7,460,172.2,460z"
}), React.createElement("path", {
  id: "Path_58_",
  className: "st3",
  d: "M172.2,414c-20.5,0-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-20.1-17.8-40.6-17.8c-12.5,0-21.5,3.5-28.5,8.1v17.7c8-6.5,15-11.8,28.5-11.8c15.2,0,22.6,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2c15.2,0,22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8v-14c-15.2,0-22.5-6.6-31-14.2C203.2,423.4,192.7,414,172.2,414z"
}), React.createElement("path", {
  id: "Path_59_",
  className: "st3",
  d: "M172.2,369c-20.5,0-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2 c-9.3-8.3-20.1-17.8-40.6-17.8c-12.5,0-21.5,3.5-28.5,8.1v17.7c8-6.5,15-11.8,28.5-11.8c15.2,0,22.6,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8s31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2c15.2,0,22.5,6.6,31.1,14.2 c9.3,8.3,19.9,17.8,40.4,17.8v-14c-15.2,0-22.5-6.6-31-14.2C203.2,378.4,192.7,369,172.2,369z"
})), React.createElement("g", {
  id: "Group_6_",
  transform: "translate(184.000000, 4.000000)",
  className: "st4"
}, React.createElement("path", {
  id: "Path_60_",
  className: "st5",
  d: "M25.6-1h-25c21,0.1,37.9,17.1,38,38v478h25V37C63.5,16,46.6-1,25.6-1z"
})), React.createElement("g", {
  id: "Group_7_",
  transform: "translate(4.000000, 4.000000)",
  className: "st6"
}, React.createElement("path", {
  id: "Path_61_",
  className: "st7",
  d: "M49-1H39C18.1-1,0.6,16.1,0.6,37v478h10V37C10.6,16.1,28.1-1,49-1z"
})), React.createElement("path", {
  id: "border_3_",
  className: "st8",
  d: "M209.6,3c21,0.1,37.9,17,38,38v477.7H5V41C5.1,20,22,3.1,43,3H209.6L209.6,3z M252.6,523.7 V41c0-23.7-19.3-43-43-43l0,0H43C19.3-2,0,17.3,0,41v478v4.7"
})), React.createElement("g", {
  id: "small-hill_2_"
}, React.createElement("path", {
  id: "Path_62_",
  className: "st2",
  d: "M336.5,518.8H129V255c0.1-21,17-37.9,38-38h131.5c21,0.1,37.9,17,38,38V518.8L336.5,518.8z"
}), React.createElement("g", {
  id: "pattern_group_4_",
  transform: "translate(2.000000, 2.000000)"
}, React.createElement("path", {
  id: "Path_63_",
  className: "st3",
  d: "M337.4,518v-15.7c-9,3.5-14.9,9.2-20.6,14.3c-1.1,1-2.3,2-3.4,3h21.7 C335.6,518.9,336.4,518.3,337.4,518L337.4,518z"
}), React.createElement("path", {
  id: "Path_64_",
  className: "st3",
  d: "M254.5,516.6c-9.3-8.3-19.9-17.9-40.4-17.9s-31.1,9.6-40.4,17.9c-1.1,1-2.2,2-3.2,3h21.7 c5.7-4,12.2-6.6,21.9-6.6s16.2,2.6,21.9,6.6h21.7C256.6,518.7,255.6,517.6,254.5,516.6z"
}), React.createElement("path", {
  id: "Path_65_",
  className: "st3",
  d: "M214.1,467.7c15.2,0,22.5,6.6,31,14.2c9.3,8.3,19.9,17.8,40.4,17.8s31.3-9.4,40.6-17.8 c3.5-3.3,7.3-6.2,11.3-8.8v-15.7c-9,3.5-14.9,9-20.6,14.1c-8.5,7.6-16,14.2-31.1,14.2s-22.6-6.6-31.1-14.2 c-9.3-8.3-19.9-17.8-40.4-17.8s-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31.1,14.2c-6.3,0.1-12.6-1.3-18.2-4.3v15.3 c5.8,2.1,12,3.1,18.2,3c20.5,0,31.1-9.4,40.4-17.8C191.5,474.3,198.9,467.7,214.1,467.7z"
}), React.createElement("path", {
  id: "Path_66_",
  className: "st3",
  d: "M183,435.9c8.5-7.6,15.9-14.2,31-14.2s22.5,6.6,31,14.2c9.3,8.3,19.9,17.8,40.4,17.8 s31.3-9.4,40.6-17.8c3.5-3.3,7.3-6.2,11.3-8.8v-15.7c-9,3.5-14.9,9-20.6,14.1c-8.5,7.6-16,14.2-31.1,14.2s-22.6-6.6-31.1-14.2 c-9.3-8.3-19.9-17.8-40.4-17.8s-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31.1,14.2c-6.3,0.1-12.6-1.3-18.2-4.3v15.3 c5.8,2.1,12,3.1,18.2,3C163.1,453.7,173.7,444.2,183,435.9z"
}), React.createElement("path", {
  id: "Path_67_",
  className: "st3",
  d: "M316.8,380.5c-8.5,7.6-16,14.2-31.1,14.2s-22.6-6.6-31.1-14.2c-9.3-8.3-19.9-17.8-40.4-17.8 s-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31.1,14.2c-6.3,0.1-12.6-1.3-18.2-4.3v15.3c5.8,2.1,12,3.1,18.2,3 c20.5,0,31.1-9.5,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2c15.2,0,22.5,6.6,31.1,14.2c9.3,8.3,19.9,17.8,40.4,17.8 c20.5,0,31.3-9.4,40.6-17.8c3.5-3.3,7.3-6.2,11.3-8.8v-15.7C328.4,369.9,322.4,375.4,316.8,380.5z"
}), React.createElement("path", {
  id: "Path_68_",
  className: "st3",
  d: "M316.8,334.5c-8.5,7.6-16,14.2-31.1,14.2s-22.6-6.6-31.1-14.2c-9.3-8.3-19.9-17.8-40.4-17.8 s-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31.1,14.2c-6.3,0.1-12.6-1.3-18.2-4.3v15.3c5.8,2.1,12,3.1,18.2,3 c20.5,0,31.1-9.5,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2c15.2,0,22.5,6.6,31.1,14.2c9.3,8.3,19.9,17.8,40.4,17.8 c20.5,0,31.3-9.4,40.6-17.8c3.5-3.3,7.3-6.2,11.3-8.8v-15.7C328.4,323.9,322.4,329.4,316.8,334.5z"
}), React.createElement("path", {
  id: "Path_69_",
  className: "st3",
  d: "M316.8,289.5c-8.5,7.6-16,14.2-31.1,14.2s-22.6-6.6-31.1-14.2c-9.3-8.3-19.9-17.8-40.4-17.8 s-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31.1,14.2c-6.3,0.1-12.6-1.3-18.2-4.3v15.3c5.8,2.1,12,3.1,18.2,3 c20.5,0,31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2s22.5,6.6,31.1,14.2c9.3,8.3,19.9,17.8,40.4,17.8 c20.5,0,31.3-9.4,40.6-17.8c3.5-3.3,7.3-6.2,11.3-8.8v-15.7C328.4,278.9,322.4,284.4,316.8,289.5z"
}), React.createElement("path", {
  id: "Path_70_",
  className: "st3",
  d: "M316.6,243.5c-8.5,7.6-15.9,14.2-31,14.2s-22.5-6.6-31-14.2c-9.3-8.3-19.9-17.8-40.4-17.8 s-31.1,9.4-40.4,17.8c-8.5,7.6-15.9,14.2-31.1,14.2c-6.3,0.1-12.6-1.3-18.2-4.3v15.3c5.8,2.1,12,3.1,18.2,3 c20.5,0,31.1-9.4,40.4-17.8c8.5-7.6,15.9-14.2,31.1-14.2s22.5,6.6,31.1,14.2c9.3,8.3,19.9,17.8,40.4,17.8 c20.5,0,31.1-9.4,40.4-17.8c3.2-3.1,6.7-5.9,10.4-8.4c-0.9-4.7-2.6-9.2-5.1-13.3C325.5,235.5,320.9,239.6,316.6,243.5z"
}), React.createElement("path", {
  id: "Path_71_",
  className: "st3",
  d: "M178.9,212.7H165c-11.6,0-22.6,4.9-30.3,13.6c2.6,0.4,5.3,0.6,7.9,0.6 C160.3,226.8,170.5,219.7,178.9,212.7z"
}), React.createElement("path", {
  id: "Path_72_",
  className: "st3",
  d: "M285.5,226.8c13.6,0,22.8-4.1,30.2-9.3c-5.9-3.2-12.5-4.8-19.2-4.8h-7.1 c-1.2,0-2.5,0.2-3.9,0.2c-1.4,0-2.6-0.2-3.9-0.2h-32.4C257.7,219.7,267.9,226.8,285.5,226.8z"
})), React.createElement("path", {
  id: "border_4_",
  className: "st8",
  d: "M298.5,217c21,0.1,37.9,17,38,38v263.8H129V255c0.1-21,17-37.9,38-38H298.5L298.5,217z  M298.5,212H167c-23.7,0-43,19.3-43,43v268.8h217.5V255C341.5,231.3,322.2,212,298.5,212L298.5,212L298.5,212z"
}), React.createElement("g", {
  id: "Group_8_",
  transform: "translate(5.000000, 4.000000)",
  className: "st6"
}, React.createElement("path", {
  id: "Path_73_",
  className: "st7",
  d: "M172,212.7h-10c-20.9,0-37.6,17.4-37.6,38.3v263.7h10V251 C134.4,230.1,151.1,212.7,172,212.7z"
})), React.createElement("g", {
  id: "Group_9_",
  transform: "translate(149.000000, 4.000000)",
  className: "st4"
}, React.createElement("path", {
  id: "Path_74_",
  className: "st5",
  d: "M149.5,212.7h-25c20.9,0,37.9,17.4,37.9,38.3v263.7h25V251 C187.4,230.1,170.4,212.7,149.5,212.7z"
}))))), React.createElement("g", {
  id: "palmtrees",
  transform: "translate(448.000000, 126.000000)"
}, React.createElement("g", {
  id: "short-palmtree",
  transform: "translate(169.000000, 210.000000)"
}, React.createElement("g", null, React.createElement("g", {
  id: "tree_trunk",
  transform: "translate(101.000000, 130.000000)"
}, React.createElement("rect", {
  id: "tree_trunk_bg",
  x: 5.3,
  y: 5,
  className: "st9",
  width: 20,
  height: 308.9
}), React.createElement("g", {
  id: "pattern",
  transform: "translate(5.000000, 11.000000)"
}, React.createElement("path", {
  id: "Path_75_",
  className: "st10",
  d: "M0.3,280.4v15.4c1.2,0.9,2.5,1.9,3.7,2.9c1.8,1.4,3.6,2.8,5.5,4.2h10.8v-8.2 c-2.3-1.6-4.6-3.4-6.9-5.2C9.4,286.1,5,283.1,0.3,280.4z"
}), React.createElement("path", {
  id: "Path_76_",
  className: "st10",
  d: "M13.4,88.3c-4-3.4-8.4-6.4-13.1-9.1v15.4c1.2,0.9,2.5,1.9,3.7,2.9 c4.7,3.7,9.8,7.7,16.3,10.7V93.5C18,91.9,15.8,90.1,13.4,88.3z"
}), React.createElement("path", {
  id: "Path_77_",
  className: "st10",
  d: "M20.3,68.5V53.8c-2.3-1.6-4.6-3.4-6.9-5.2c-4-3.4-8.4-6.4-13.1-9.1v15.4 c1.2,0.9,2.5,1.9,3.7,2.9C8.8,61.5,13.8,65.5,20.3,68.5z"
}), React.createElement("path", {
  id: "Path_78_",
  className: "st10",
  d: "M20.3,27.9V13.2c-2.3-1.6-4.6-3.4-6.9-5.2C9.4,4.6,5,1.5,0.3-1.2v15.4 c1.2,0.9,2.5,1.9,3.7,2.9C8.8,20.9,13.8,24.9,20.3,27.9z"
}), React.createElement("path", {
  id: "Path_79_",
  className: "st10",
  d: "M13.4,248.9c-4-3.4-8.4-6.4-13.1-9.1v15.4c1.2,0.9,2.5,1.9,3.7,2.9 c4.7,3.7,9.8,7.7,16.3,10.7v-14.7C18,252.5,15.8,250.7,13.4,248.9z"
}), React.createElement("path", {
  id: "Path_80_",
  className: "st10",
  d: "M13.4,209.2c-4-3.4-8.4-6.4-13.1-9.1v15.4c1.2,0.9,2.5,1.9,3.7,2.9 c4.7,3.7,9.8,7.7,16.3,10.7v-14.7C18,212.8,15.8,211,13.4,209.2z"
}), React.createElement("path", {
  id: "Path_81_",
  className: "st10",
  d: "M13.4,168.6c-4-3.4-8.4-6.4-13.1-9.1v15.4c1.2,0.9,2.5,1.9,3.7,2.9 c4.7,3.7,9.8,7.7,16.3,10.7v-14.7C18,172.2,15.8,170.4,13.4,168.6z"
}), React.createElement("path", {
  id: "Path_82_",
  className: "st10",
  d: "M13.4,128.9c-4-3.4-8.4-6.4-13.1-9.1v15.4c1.2,0.9,2.5,1.9,3.7,2.9 c4.7,3.7,9.8,7.7,16.3,10.7v-14.7C18,132.5,15.8,130.7,13.4,128.9z"
})), React.createElement("g", {
  id: "shadow",
  transform: "translate(20.000000, 5.000000)",
  className: "st4"
}, React.createElement("rect", {
  id: "Rectangle",
  x: 0.3,
  y: 0,
  className: "st11",
  width: 5,
  height: 308.9
})), React.createElement("g", {
  id: "light",
  transform: "translate(5.000000, 5.000000)",
  className: "st4"
}, React.createElement("rect", {
  id: "Rectangle_1_",
  x: 0.3,
  y: 0,
  className: "st12",
  width: 3,
  height: 308.9
})), React.createElement("path", {
  id: "border_5_",
  className: "st13",
  d: "M25.3,5v308.9h-20V5H25.3L25.3,5z M25.3,0.6h-20c-2.8,0-5,2-5,4.4v308.9 c0,2.4,2.2,4.4,5,4.4h20c2.8,0,5-2,5-4.4V5C30.3,2.6,28.1,0.6,25.3,0.6L25.3,0.6z"
})), React.createElement("g", {
  id: "palmtree_leaves"
}, React.createElement("path", {
  id: "leaves_border",
  className: "st13",
  d: "M227.1,125.2c-3.9-21.9-25.1-36.5-52.8-36.5c-13.4-0.1-26.6,3.7-38,10.8 c-0.6,0.4-1.1,0.7-1.6,1.1c8.9-10.1,17-13.9,27.2-16.3c3-0.7,7.2-1.4,11.6-2.1c20.9-3.4,35.9-6.6,37.9-16.1 c1.7-8-7.4-14.1-10.4-16.2c-9.6-6.5-19.8-9.8-30.2-9.8c-10.4,0.1-20.6,3.2-29.3,8.9c4-6.5,8.1-10.7,14.2-12.5 c2.6-0.8,6.9-1.2,11.1-1.6c9.8-0.9,18.3-1.6,20.1-8.3c1.7-6.2-4.9-11.9-12.3-17.1C165.6,3.1,157.5,0,150,0 c-18.9,0-27.9,19-33.3,38.6C111.3,19,102.3,0,83.4,0c-7.5,0-15.6,3.1-24.7,9.5c-7.4,5.2-13.9,10.8-12.3,17.1 c1.8,6.6,10.3,7.4,20.1,8.3c4.1,0.4,8.4,0.8,11.1,1.6c7.3,2.2,11.7,7.8,16.6,16.6C83.4,44.5,71.3,40,59.2,40 c-10.5,0-20.7,3.3-30.2,9.8c-3,2-12.1,8.2-10.4,16.2c2.1,9.5,17,12.6,37.9,16.1c4.4,0.7,8.6,1.4,11.6,2.1 c11.1,2.6,19.9,6.9,29.8,19.4c-1.8-1.4-3.8-2.8-5.9-4.2c-11.4-7.1-24.5-10.8-38-10.8c-27.7,0-48.9,14.7-52.8,36.5 c-0.6,2.9,0.1,5.9,1.9,8.3c2.3,2.7,6,4.2,11.3,4.2l0,0c11.6,0,29.6-6.5,32.7-7.6c5.3-0.9,10.7-1.3,16.1-1.3 c11.8,0,29.6,1.8,46.9,10.4l0.9,0.4l0,0c2,1,4.4,1,6.4,0h0l0.9-0.4c17.3-8.7,35-10.5,46.9-10.5c5.4,0,10.8,0.4,16.2,1.2 c3.1,1.1,21.1,7.5,32.6,7.5c5.3,0,9.1-1.3,11.3-4C227.1,131,227.8,128,227.1,125.2z"
}), React.createElement("g", {
  id: "leaf_group_top",
  transform: "translate(49.000000, 2.000000)"
}, React.createElement("g", {
  id: "leaf"
}, React.createElement("path", {
  id: "leaf-2",
  className: "st2",
  d: "M67,82c0,0,3.7-10.9-1.9-35c-7.1-30.9-19.6-58.5-52.6-35.4c-26.9,18.9,5.5,14.3,17.5,18 C46.9,34.8,50.5,53.2,67,82z"
}), React.createElement("path", {
  id: "border-2",
  className: "st13",
  d: "M34.4,3c17.3,0,25.5,21.1,30.8,44C70.7,71,67,82,67,82C50.5,53.2,46.9,34.8,30.1,29.6 c-12-3.7-44.4,0.9-17.5-18C21.2,5.6,28.3,3,34.4,3L34.4,3z M34.4,1c-6.8,0-14.5,3-23,9c-8.7,6.1-12,10.3-11.1,13.8 c1.2,4.6,8.8,5.3,17.5,6c4.3,0.4,8.7,0.8,11.7,1.7C40.8,35,45.7,44.8,53.8,61.1c3.2,6.4,6.8,13.7,11.5,21.8 c0.4,0.6,1,1,1.7,1c0.1,0,0.1,0,0.2,0c0.8-0.1,1.4-0.6,1.7-1.4c0.2-0.5,3.8-11.7-1.8-36.1C63.9,32.6,60.4,22.7,56,15.4 C50.3,5.8,43,1,34.4,1L34.4,1L34.4,1z"
})), React.createElement("g", {
  id: "shadow-2",
  transform: "translate(2.000000, 3.000000)",
  className: "st4"
}, React.createElement("path", {
  id: "Path_83_",
  className: "st5",
  d: "M10.6,8.6C19,2.7,26.1,0.1,32.1,0c-4.4,1.2-8.7,3-12.6,5.3c-28.7,15.9,3.9,14.8,15.5,19.8 c15.8,6.8,17.7,24.8,30.1,53.8l0,0.1C48.5,50.2,44.9,31.8,28.1,26.6C16.1,22.9-16.3,27.5,10.6,8.6z"
})), React.createElement("g", {
  id: "leaf-3",
  transform: "translate(65.000000, 0.000000)"
}, React.createElement("path", {
  id: "leaf-4",
  className: "st2",
  d: "M3.4,82c0,0-3.7-10.9,1.9-35c7.1-30.9,19.6-58.5,52.6-35.4c26.9,18.9-5.5,14.3-17.5,18 C23.5,34.8,19.9,53.2,3.4,82z"
}), React.createElement("path", {
  id: "border-3",
  d: "M36,3c6.1,0,13.2,2.6,21.8,8.6c26.9,18.9-5.5,14.3-17.5,18C23.5,34.8,19.9,53.2,3.4,82 c0,0-3.7-10.9,1.9-35C10.5,24.1,18.7,3,36,3L36,3z M36,1L36,1c-8.6,0-15.9,4.8-21.6,14.4C10,22.7,6.5,32.6,3.3,46.5 c-5.6,24.4-2,35.6-1.8,36.1c0.3,0.7,0.9,1.3,1.7,1.4c0.1,0,0.1,0,0.2,0c0.7,0,1.4-0.4,1.7-1c4.7-8.1,8.3-15.4,11.5-21.8 c8.1-16.3,13-26.2,24.3-29.6c2.9-0.9,7.4-1.3,11.7-1.7c8.7-0.8,16.3-1.5,17.5-6c1-3.6-2.4-7.7-11.1-13.8C50.5,4,42.8,1,36,1 L36,1L36,1z"
})), React.createElement("g", {
  id: "shadow-3",
  transform: "translate(68.000000, 3.000000)",
  className: "st4"
}, React.createElement("path", {
  id: "Path_84_",
  className: "st5",
  d: "M54.8,8.6C46.4,2.7,39.3,0.1,33.3,0C37.7,1.2,42,3,46,5.3c28.7,15.9-3.9,14.8-15.5,19.8 C14.7,31.8,12.8,49.8,0.4,78.9l0,0.1c16.5-28.8,20.1-47.2,36.9-52.4C49.4,22.9,81.7,27.5,54.8,8.6z"
}))), React.createElement("g", {
  id: "leaf_group_center",
  transform: "translate(21.000000, 42.000000)"
}, React.createElement("g", {
  id: "leaf-5",
  transform: "translate(89.000000, 0.000000)"
}, React.createElement("g", {
  id: "leaf-6"
}, React.createElement("path", {
  id: "leaf-7",
  className: "st2",
  d: "M5.4,78c0,0-8.1-12.4,1.9-35c13-29.6,47.7-53.6,81.1-31C116,30.6,68,33.3,50.8,37.3 S21.9,49.2,5.4,78z"
}), React.createElement("path", {
  id: "border-4",
  className: "st13",
  d: "M60.9,3c8.9,0,18.2,2.7,27.5,8.9C116,30.6,68,33.3,50.8,37.3S21.9,49.2,5.4,78 c0,0-8.1-12.4,1.9-35C16.7,21.5,37.5,3,60.9,3L60.9,3z M60.9,0.6L60.9,0.6c-11.5,0-23,4.5-33.3,12.6 C18,20.9,10.4,30.8,5.4,42C-4.8,65.4,3.4,78.3,3.7,78.8c0.4,0.5,1,0.8,1.7,0.8h0.1c0.7,0.1,1.3-0.3,1.7-0.8 C23.6,50.1,34.9,43,51.3,39.1c3.1-0.7,7.3-1.4,11.8-2.1c19.1-3.2,33.8-6.1,35.5-13.7c0.9-4-2.1-8.5-9.1-13.2 C80.4,3.9,70.7,0.6,60.9,0.6L60.9,0.6L60.9,0.6z"
})), React.createElement("g", {
  id: "shadow-4",
  transform: "translate(3.000000, 3.000000)",
  className: "st4"
}, React.createElement("path", {
  id: "Path_85_",
  className: "st5",
  d: "M85.3,8.9c-6-4.2-12.9-7-20.2-8.3c3.1,1,6,2.3,8.8,3.9c29.3,15.9-19.1,19.1-35.7,24.8 C22.8,34.5,13,46,0.8,71.5c0.4,1.2,0.9,2.4,1.5,3.5c16.5-28.8,28.3-36.7,45.4-40.7S113,27.6,85.3,8.9z"
}))), React.createElement("g", {
  id: "leaf-8",
  transform: "translate(0.000000, 1.000000)"
}, React.createElement("g", {
  id: "leaf-9"
}, React.createElement("path", {
  id: "leaf-10",
  className: "st2",
  d: "M93.7,77c0,0,8.1-12.4-1.9-35c-13-29.6-47.7-53.6-81.1-31c-27.6,18.7,20.4,21.3,37.5,25.4 S77.2,48.2,93.7,77z"
}), React.createElement("path", {
  id: "border-5",
  className: "st13",
  d: "M38.2,2C61.6,2,82.4,20.5,91.8,42c9.9,22.6,1.9,35,1.9,35 C77.2,48.2,65.4,40.3,48.2,36.3s-65.2-6.7-37.5-25.4C19.9,4.7,29.2,2,38.2,2L38.2,2z M38.2,0C28.3,0,18.7,3.1,9.6,9.3 c-7,4.7-10,9-9.1,13C2.1,29.9,16.9,32.9,36,36.1c4.5,0.7,8.7,1.4,11.8,2.2c20.9,4.9,31.2,17,44.1,39.5 c0.4,0.6,1,0.9,1.7,0.8h0.1c0.6,0.1,1.3-0.2,1.7-0.7c0.4-0.5,8.6-13.5-1.7-36.8c-5-11.2-12.6-21.1-22.2-28.7 C61.2,4.3,49.7,0,38.2,0L38.2,0L38.2,0z"
})), React.createElement("g", {
  id: "shadow-5",
  transform: "translate(2.000000, 2.000000)",
  className: "st4"
}, React.createElement("path", {
  id: "Path_86_",
  className: "st5",
  d: "M8.7,8.9c6-4.2,12.9-7,20.2-8.3c-3.1,1-6,2.3-8.8,3.9C-9.2,20.4,39.1,23.6,55.8,29.3 C71.2,34.5,81,46,93.2,71.5c-0.4,1.2-0.9,2.4-1.5,3.5C75.2,46.2,63.4,38.3,46.2,34.3S-18.9,27.6,8.7,8.9z"
})))), React.createElement("g", {
  id: "leaf_group_bottom",
  transform: "translate(6.000000, 93.000000)"
}, React.createElement("g", {
  id: "leaf-11",
  transform: "translate(109.000000, 0.000000)"
}, React.createElement("path", {
  id: "leaf-12",
  className: "st2",
  d: "M1,41.6c0,0,0.1-16.3,23.1-31c30.1-19.3,77.4-10,83.1,22.5c2.6,14.7-39.6-1.1-39.6-1.1 S33.7,25.2,1,41.6z"
}), React.createElement("g", {
  id: "shadow-6",
  transform: "translate(0.000000, 10.000000)",
  className: "st4"
}, React.createElement("path", {
  id: "Path_87_",
  className: "st5",
  d: "M107.2,23c-1.6-9.1-6.8-17.2-14.4-22.5c2.9,3.7,5,8,6.1,12.6c3.7,14.5-39.6,1.8-39.6,1.8 s-28.1-3.5-56.7,9.8c-0.9,2.2-1.4,4.5-1.6,6.9C33.7,15.2,67.6,22,67.6,22S109.8,37.7,107.2,23z"
}))), React.createElement("g", {
  id: "leaf-13"
}, React.createElement("path", {
  id: "leaf-14",
  className: "st2",
  d: "M106.3,41.6c0,0-0.1-16.3-23.1-31C53.2-8.7,5.9,0.6,0.1,33C-2.5,47.7,39.8,32,39.8,32 S73.6,25.2,106.3,41.6z"
}), React.createElement("g", {
  id: "shadow-7",
  transform: "translate(0.000000, 10.000000)",
  className: "st4"
}, React.createElement("path", {
  id: "Path_88_",
  className: "st5",
  d: "M0.1,23C1.8,13.9,6.9,5.8,14.5,0.5c-2.9,3.7-5,8-6.1,12.6C4.7,27.6,48,15,48,15 s28.1-3.5,56.7,9.8c0.9,2.2,1.4,4.5,1.6,6.9C73.6,15.2,39.8,22,39.8,22S-2.5,37.7,0.1,23z"
}))))))), React.createElement("g", {
  id: "long-palmtree"
}, React.createElement("g", null, React.createElement("g", {
  id: "tree_trunk_1_",
  transform: "translate(101.000000, 130.000000)"
}, React.createElement("rect", {
  id: "tree_trunk_bg_1_",
  x: 5.3,
  y: 5.2,
  className: "st9",
  width: 20,
  height: 518.3
}), React.createElement("g", {
  id: "pattern_1_",
  transform: "translate(5.000000, 11.000000)"
}, React.createElement("path", {
  id: "Path_89_",
  className: "st10",
  d: "M13.4,93.1c-4-3.5-8.4-6.7-13.1-9.6v16.2c1.2,1,2.5,2,3.7,3.1c4.7,3.9,9.8,8.1,16.3,11.3 V98.5C18,96.8,15.8,95,13.4,93.1z"
}), React.createElement("path", {
  id: "Path_90_",
  className: "st10",
  d: "M20.3,72.3V56.9c-2.3-1.7-4.6-3.5-6.9-5.5c-4-3.5-8.4-6.8-13.1-9.6V58 c1.2,1,2.5,2,3.7,3.1C8.8,65,13.8,69.1,20.3,72.3z"
}), React.createElement("path", {
  id: "Path_91_",
  className: "st10",
  d: "M20.3,29.7V14.3c-2.3-1.7-4.6-3.5-6.9-5.5C9.4,5.3,5,2.1,0.3-0.7v16.2 c1.2,1,2.5,2,3.7,3.1C8.8,22.4,13.8,26.6,20.3,29.7z"
}), React.createElement("path", {
  id: "Path_92_",
  className: "st10",
  d: "M0.3,504.6v7.9h11.1C8,509.6,4.3,506.9,0.3,504.6L0.3,504.6z"
}), React.createElement("path", {
  id: "Path_93_",
  className: "st10",
  d: "M13.4,472.5c-4-3.5-8.4-6.7-13.1-9.6v16.2c1.2,1,2.5,2,3.7,3.1c4.7,3.9,9.8,8.1,16.3,11.3 V478C18,476.3,15.8,474.4,13.4,472.5z"
}), React.createElement("path", {
  id: "Path_94_",
  className: "st10",
  d: "M20.3,450.8v-15.4c-2.3-1.7-4.6-3.5-6.9-5.5c-4-3.5-8.4-6.8-13.1-9.6v16.2 c1.2,1,2.5,2,3.7,3.1C8.8,443.5,13.8,447.7,20.3,450.8z"
}), React.createElement("path", {
  id: "Path_95_",
  className: "st10",
  d: "M20.3,409.2v-15.4c-2.3-1.7-4.6-3.5-6.9-5.5c-4-3.5-8.4-6.8-13.1-9.6v16.2 c1.2,1,2.5,2,3.7,3.1C8.8,401.9,13.8,406,20.3,409.2z"
}), React.createElement("path", {
  id: "Path_96_",
  className: "st10",
  d: "M20.3,366.6v-15.4c-2.3-1.7-4.6-3.5-6.9-5.5c-4-3.5-8.4-6.8-13.1-9.6v16.2 c1.2,1,2.5,2,3.7,3.1C8.8,359.3,13.8,363.5,20.3,366.6z"
}), React.createElement("path", {
  id: "Path_97_",
  className: "st10",
  d: "M20.3,325v-15.4c-2.3-1.7-4.6-3.5-6.9-5.5c-4-3.5-8.4-6.8-13.1-9.6v16.2 c1.2,1,2.5,2,3.7,3.1C8.8,317.6,13.8,321.8,20.3,325z"
}), React.createElement("path", {
  id: "Path_98_",
  className: "st10",
  d: "M13.4,261.5c-4-3.5-8.4-6.7-13.1-9.6v16.2c1.2,1,2.5,2,3.7,3.1c4.7,3.9,9.8,8.1,16.3,11.3 V267C18,265.3,15.8,263.4,13.4,261.5z"
}), React.createElement("path", {
  id: "Path_99_",
  className: "st10",
  d: "M13.4,219.9c-4-3.5-8.4-6.7-13.1-9.6v16.2c1.2,1,2.5,2,3.7,3.1c4.7,3.9,9.8,8.1,16.3,11.3 v-15.4C18,223.6,15.8,221.8,13.4,219.9z"
}), React.createElement("path", {
  id: "Path_100_",
  className: "st10",
  d: "M13.4,177.3c-4-3.5-8.4-6.7-13.1-9.6v16.2c1.2,1,2.5,2,3.7,3.1 c4.7,3.9,9.8,8.1,16.3,11.3v-15.4C18,181.1,15.8,179.2,13.4,177.3z"
}), React.createElement("path", {
  id: "Path_101_",
  className: "st10",
  d: "M13.4,135.6c-4-3.5-8.4-6.7-13.1-9.6v16.2c1.2,1,2.5,2,3.7,3.1 c4.7,3.9,9.8,8.1,16.3,11.3v-15.4C18,139.4,15.8,137.6,13.4,135.6z"
})), React.createElement("g", {
  id: "shadow_1_",
  transform: "translate(20.000000, 5.000000)",
  className: "st4"
}, React.createElement("rect", {
  id: "Rectangle_2_",
  x: 0.3,
  y: 0.2,
  className: "st11",
  width: 5,
  height: 518.3
})), React.createElement("g", {
  id: "Group_10_",
  transform: "translate(5.000000, 5.000000)",
  className: "st4"
}, React.createElement("rect", {
  id: "Rectangle_3_",
  x: 0.3,
  y: 0.2,
  className: "st12",
  width: 3,
  height: 518.3
})), React.createElement("path", {
  id: "border_6_",
  className: "st13",
  d: "M25.3,5.2v518.3h-20V5.2H25.3L25.3,5.2z M25.3,0.6h-20c-2.8,0-5,2.1-5,4.6v518.3 c0,2.6,2.2,4.6,5,4.6h20c2.8,0,5-2.1,5-4.6V5.2C30.3,2.7,28.1,0.6,25.3,0.6L25.3,0.6z"
})), React.createElement("g", {
  id: "palmtree_leaves_1_"
}, React.createElement("path", {
  id: "leaves_border_1_",
  className: "st13",
  d: "M227.1,125.2c-3.9-21.9-25.1-36.5-52.8-36.5c-13.4-0.1-26.6,3.7-38,10.8 c-0.6,0.4-1.1,0.7-1.6,1.1c8.9-10.1,17-13.9,27.2-16.3c3-0.7,7.2-1.4,11.6-2.1c20.9-3.4,35.9-6.6,37.9-16.1 c1.7-8-7.4-14.1-10.4-16.2c-9.6-6.5-19.8-9.8-30.2-9.8c-10.4,0.1-20.6,3.2-29.3,8.9c4-6.5,8.1-10.7,14.2-12.5 c2.6-0.8,6.9-1.2,11.1-1.6c9.8-0.9,18.3-1.6,20.1-8.3c1.7-6.2-4.9-11.9-12.3-17.1C165.6,3.1,157.5,0,150,0 c-18.9,0-27.9,19-33.3,38.6C111.3,19,102.3,0,83.4,0c-7.5,0-15.6,3.1-24.7,9.5c-7.4,5.2-13.9,10.8-12.3,17.1 c1.8,6.6,10.3,7.4,20.1,8.3c4.1,0.4,8.4,0.8,11.1,1.6c7.3,2.2,11.7,7.8,16.6,16.6C83.4,44.5,71.3,40,59.2,40 c-10.5,0-20.7,3.3-30.2,9.8c-3,2-12.1,8.2-10.4,16.2c2.1,9.5,17,12.6,37.9,16.1c4.4,0.7,8.6,1.4,11.6,2.1 c11.1,2.6,19.9,6.9,29.8,19.4c-1.8-1.4-3.8-2.8-5.9-4.2c-11.4-7.1-24.5-10.8-38-10.8c-27.7,0-48.9,14.7-52.8,36.5 c-0.6,2.9,0.1,5.9,1.9,8.3c2.3,2.7,6,4.2,11.3,4.2l0,0c11.6,0,29.6-6.5,32.7-7.6c5.3-0.9,10.7-1.3,16.1-1.3 c11.8,0,29.6,1.8,46.9,10.4l0.9,0.4l0,0c2,1,4.4,1,6.4,0h0l0.9-0.4c17.3-8.7,35-10.5,46.9-10.5c5.4,0,10.8,0.4,16.2,1.2 c3.1,1.1,21.1,7.5,32.6,7.5c5.3,0,9.1-1.3,11.3-4C227.1,131,227.8,128,227.1,125.2L227.1,125.2z"
}), React.createElement("g", {
  id: "leaf_group_top_1_",
  transform: "translate(49.000000, 2.000000)"
}, React.createElement("g", {
  id: "leaf_1_"
}, React.createElement("path", {
  id: "leaf-2_1_",
  className: "st2",
  d: "M67,82c0,0,3.7-10.9-1.9-35c-7.1-30.9-19.6-58.5-52.6-35.4c-26.9,18.9,5.5,14.3,17.5,18 C46.9,34.8,50.5,53.2,67,82z"
}), React.createElement("path", {
  id: "border-2_1_",
  className: "st13",
  d: "M34.4,3c17.3,0,25.5,21.1,30.8,44C70.7,71,67,82,67,82C50.5,53.2,46.9,34.8,30.1,29.6 c-12-3.7-44.4,0.9-17.5-18C21.2,5.6,28.3,3,34.4,3L34.4,3z M34.4,1c-6.8,0-14.5,3-23,9c-8.7,6.1-12,10.3-11.1,13.8 c1.2,4.6,8.8,5.3,17.5,6c4.3,0.4,8.7,0.8,11.7,1.7C40.8,35,45.7,44.8,53.8,61.1c3.2,6.4,6.8,13.7,11.5,21.8 c0.4,0.6,1,1,1.7,1c0.1,0,0.1,0,0.2,0c0.8-0.1,1.4-0.6,1.7-1.4c0.2-0.5,3.8-11.7-1.8-36.1C63.9,32.6,60.4,22.7,56,15.4 C50.3,5.8,43,1,34.4,1L34.4,1L34.4,1z"
})), React.createElement("g", {
  id: "Group_11_",
  transform: "translate(2.000000, 3.000000)",
  className: "st4"
}, React.createElement("path", {
  id: "Path_102_",
  className: "st5",
  d: "M10.6,8.6C19,2.7,26.1,0.1,32.1,0c-4.4,1.2-8.7,3-12.6,5.3 c-28.7,15.9,3.9,14.8,15.5,19.8c15.8,6.8,17.7,24.8,30.1,53.8l0,0.1C48.5,50.2,44.9,31.8,28.1,26.6 C16.1,22.9-16.3,27.5,10.6,8.6z"
})), React.createElement("g", {
  id: "leaf-3_1_",
  transform: "translate(65.000000, 0.000000)"
}, React.createElement("path", {
  id: "leaf-4_1_",
  className: "st2",
  d: "M3.4,82c0,0-3.7-10.9,1.9-35c7.1-30.9,19.6-58.5,52.6-35.4c26.9,18.9-5.5,14.3-17.5,18 C23.5,34.8,19.9,53.2,3.4,82z"
}), React.createElement("path", {
  id: "border-3_1_",
  d: "M36,3c6.1,0,13.2,2.6,21.8,8.6c26.9,18.9-5.5,14.3-17.5,18C23.5,34.8,19.9,53.2,3.4,82 c0,0-3.7-10.9,1.9-35C10.5,24.1,18.7,3,36,3L36,3z M36,1L36,1c-8.6,0-15.9,4.8-21.6,14.4C10,22.7,6.5,32.6,3.3,46.5 c-5.6,24.4-2,35.6-1.8,36.1c0.3,0.7,0.9,1.3,1.7,1.4c0.1,0,0.1,0,0.2,0c0.7,0,1.4-0.4,1.7-1c4.7-8.1,8.3-15.4,11.5-21.8 c8.1-16.3,13-26.2,24.3-29.6c2.9-0.9,7.4-1.3,11.7-1.7c8.7-0.8,16.3-1.5,17.5-6c1-3.6-2.4-7.7-11.1-13.8C50.5,4,42.8,1,36,1 L36,1L36,1z"
})), React.createElement("g", {
  id: "Group_12_",
  transform: "translate(68.000000, 3.000000)",
  className: "st4"
}, React.createElement("path", {
  id: "Path_103_",
  className: "st5",
  d: "M54.8,8.6C46.4,2.7,39.3,0.1,33.3,0C37.7,1.2,42,3,46,5.3c28.7,15.9-3.9,14.8-15.5,19.8 C14.7,31.8,12.8,49.8,0.4,78.9l0,0.1c16.5-28.8,20.1-47.2,36.9-52.4C49.4,22.9,81.7,27.5,54.8,8.6z"
}))), React.createElement("g", {
  id: "leaf_group_center_1_",
  transform: "translate(21.000000, 42.000000)"
}, React.createElement("g", {
  id: "leaf-5_1_",
  transform: "translate(89.000000, 0.000000)"
}, React.createElement("g", {
  id: "leaf-6_1_"
}, React.createElement("path", {
  id: "leaf-7_1_",
  className: "st2",
  d: "M5.4,78c0,0-8.1-12.4,1.9-35c13-29.6,47.7-53.6,81.1-31C116,30.6,68,33.3,50.8,37.3 S21.9,49.2,5.4,78z"
}), React.createElement("path", {
  id: "border-4_1_",
  className: "st13",
  d: "M60.9,3c8.9,0,18.2,2.7,27.5,8.9C116,30.6,68,33.3,50.8,37.3S21.9,49.2,5.4,78 c0,0-8.1-12.4,1.9-35C16.7,21.5,37.5,3,60.9,3L60.9,3z M60.9,0.6L60.9,0.6c-11.5,0-23,4.5-33.3,12.6 C18,20.9,10.4,30.8,5.4,42C-4.8,65.4,3.4,78.3,3.7,78.8c0.4,0.5,1,0.8,1.7,0.8h0.1c0.7,0.1,1.3-0.3,1.7-0.8 C23.6,50.1,34.9,43,51.3,39.1c3.1-0.7,7.3-1.4,11.8-2.1c19.1-3.2,33.8-6.1,35.5-13.7c0.9-4-2.1-8.5-9.1-13.2 C80.4,3.9,70.7,0.6,60.9,0.6L60.9,0.6L60.9,0.6z"
})), React.createElement("g", {
  id: "shadow-2_1_",
  transform: "translate(3.000000, 3.000000)",
  className: "st4"
}, React.createElement("path", {
  id: "Path_104_",
  className: "st5",
  d: "M85.3,8.9c-6-4.2-12.9-7-20.2-8.3c3.1,1,6,2.3,8.8,3.9c29.3,15.9-19.1,19.1-35.7,24.8 C22.8,34.5,13,46,0.8,71.5c0.4,1.2,0.9,2.4,1.5,3.5c16.5-28.8,28.3-36.7,45.4-40.7S113,27.6,85.3,8.9z"
}))), React.createElement("g", {
  id: "leaf-8_1_",
  transform: "translate(0.000000, 1.000000)"
}, React.createElement("g", {
  id: "leaf-9_1_"
}, React.createElement("path", {
  id: "leaf-10_1_",
  className: "st2",
  d: "M93.7,77c0,0,8.1-12.4-1.9-35c-13-29.6-47.7-53.6-81.1-31 c-27.6,18.7,20.4,21.3,37.5,25.4S77.2,48.2,93.7,77z"
}), React.createElement("path", {
  id: "border-5_1_",
  className: "st13",
  d: "M38.2,2C61.6,2,82.4,20.5,91.8,42c9.9,22.6,1.9,35,1.9,35 C77.2,48.2,65.4,40.3,48.2,36.3s-65.2-6.7-37.5-25.4C19.9,4.7,29.2,2,38.2,2L38.2,2z M38.2,0C28.3,0,18.7,3.1,9.6,9.3 c-7,4.7-10,9-9.1,13C2.1,29.9,16.9,32.9,36,36.1c4.5,0.7,8.7,1.4,11.8,2.2c20.9,4.9,31.2,17,44.1,39.5 c0.4,0.6,1,0.9,1.7,0.8h0.1c0.6,0.1,1.3-0.2,1.7-0.7c0.4-0.5,8.6-13.5-1.7-36.8c-5-11.2-12.6-21.1-22.2-28.7 C61.2,4.3,49.7,0,38.2,0L38.2,0L38.2,0z"
})), React.createElement("g", {
  id: "shadow-3_1_",
  transform: "translate(2.000000, 2.000000)",
  className: "st4"
}, React.createElement("path", {
  id: "Path_105_",
  className: "st5",
  d: "M8.7,8.9c6-4.2,12.9-7,20.2-8.3c-3.1,1-6,2.3-8.8,3.9C-9.2,20.4,39.1,23.6,55.8,29.3 C71.2,34.5,81,46,93.2,71.5c-0.4,1.2-0.9,2.4-1.5,3.5C75.2,46.2,63.4,38.3,46.2,34.3S-18.9,27.6,8.7,8.9z"
})))), React.createElement("g", {
  id: "leaf_group_bottom_1_",
  transform: "translate(6.000000, 93.000000)"
}, React.createElement("g", {
  id: "leaf-11_1_",
  transform: "translate(109.000000, 0.000000)"
}, React.createElement("path", {
  id: "leaf-12_1_",
  className: "st2",
  d: "M1,41.6c0,0,0.1-16.3,23.1-31c30.1-19.3,77.4-10,83.1,22.5c2.6,14.7-39.6-1.1-39.6-1.1 S33.7,25.2,1,41.6z"
}), React.createElement("g", {
  id: "shadow-4_1_",
  transform: "translate(0.000000, 10.000000)",
  className: "st4"
}, React.createElement("path", {
  id: "Path_106_",
  className: "st5",
  d: "M107.2,23c-1.6-9.1-6.8-17.2-14.4-22.5c2.9,3.7,5,8,6.1,12.6 c3.7,14.5-39.6,1.8-39.6,1.8s-28.1-3.5-56.7,9.8c-0.9,2.2-1.4,4.5-1.6,6.9C33.7,15.2,67.6,22,67.6,22S109.8,37.7,107.2,23z"
}))), React.createElement("g", {
  id: "leaf-13_1_"
}, React.createElement("path", {
  id: "leaf-14_1_",
  className: "st2",
  d: "M106.3,41.6c0,0-0.1-16.3-23.1-31C53.2-8.7,5.9,0.6,0.1,33C-2.5,47.7,39.8,32,39.8,32 S73.6,25.2,106.3,41.6z"
}), React.createElement("g", {
  id: "shadow-5_1_",
  transform: "translate(0.000000, 10.000000)",
  className: "st4"
}, React.createElement("path", {
  id: "Path_107_",
  className: "st5",
  d: "M0.1,23C1.8,13.9,6.9,5.8,14.5,0.5c-2.9,3.7-5,8-6.1,12.6C4.7,27.6,48,15,48,15 s28.1-3.5,56.7,9.8c0.9,2.2,1.4,4.5,1.6,6.9C73.6,15.2,39.8,22,39.8,22S-2.5,37.7,0.1,23z"
})))))))));

var SvgBackground = function SvgBackground(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 1560 780",
    style: {
      enableBackground: "new 0 0 1560 780"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBackground, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/background.421d1f71.svg";
export { ForwardRef as ReactComponent };